module.exports = __webpack_public_path__ + "img/company_active.7fba4d1e.svg";